import { render, staticRenderFns } from "./iDxPopup.vue?vue&type=template&id=33e374dc&scoped=true&"
import script from "./iDxPopup.vue?vue&type=script&lang=js&"
export * from "./iDxPopup.vue?vue&type=script&lang=js&"
import style0 from "./iDxPopup.vue?vue&type=style&index=0&id=33e374dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e374dc",
  null
  
)

export default component.exports